import { Routes } from '@angular/router';
import { MachineRange } from 'src/app/core/pages/machine-range/machine-range';
import { DashboardLayoutComponent } from 'src/app/core/layouts/dashboard-layout/dashboard-layout';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'machine-range/:machine-range-id',
        pathMatch: 'full',
        component: MachineRange
      }
    ]
  }
];
